import { useEffect } from "react";
import { useParams, Link } from "react-router";
import ComponentCard from "../../components/common/ComponentCard";
import Button from "../../components/ui/button/Button";
import MenuItemGrid from "../../components/common/MenuItem/MenuItemGrid";
import useMenuItems from '../../hooks/MenuItem/useMenuItems'
import Spinner from "../../components/ui/spinner";

const MenuItemList = () => {
  const { id } = useParams();
  const { menuItems, loading, error, refetchMenuItems } = useMenuItems(id, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });

  useEffect(() => {
    refetchMenuItems();
  }, [refetchMenuItems]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;
  
  return (
    <ComponentCard title="Menu Items">
      <MenuItemGrid menuItems={menuItems} />
      <Link to={`/menus/${id}/menu_items/new`}>
        <Button 
          size="md" 
          variant="primary"
          className="my-6"
        >
          New
        </Button>
      </Link>
    </ComponentCard>
  )
}

export default MenuItemList;
